import {
  BottomNavigation,
  BottomNavigationTab,
  Icon,
} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {useSelector} from 'react-redux';
import themeColors from '../../assets/json/custom-theme.json';
import {px} from '../../utils';

const HomeIcon = (props) => <Icon {...props} name="home-outline" />;
const ClassroomIcon = (props) => <Icon {...props} name="calendar-outline" />;
const InboxIcon = ({showBadge, ...otherProps}) => {
  return (
    <View style={styles.iconWithBadgeContainer}>
      {showBadge && <View style={styles.badge} />}
      <Icon {...otherProps} name="bell-outline" />
    </View>
  );
};
const ProfileIcon = (props) => <Icon {...props} name="person-outline" />;

const BottomTabBar = ({navigation, state}) => {
  const haveNewNotification = useSelector((val) => val.inbox.haveNewNotif);

  return (
    <BottomNavigation
      selectedIndex={state.index}
      onSelect={(index) => navigation.navigate(state.routeNames[index])}>
      <BottomNavigationTab title="Home" icon={HomeIcon} />
      <BottomNavigationTab title="Classroom" icon={ClassroomIcon} />
      <BottomNavigationTab
        title="Inbox"
        icon={(props) => (
          <InboxIcon {...props} showBadge={haveNewNotification} />
        )}
      />
      <BottomNavigationTab title="Profile" icon={ProfileIcon} />
    </BottomNavigation>
  );
};

const styles = StyleSheet.create({
  iconWithBadgeContainer: {
    position: 'relative',
  },
  badge: {
    position: 'relative',
    backgroundColor: themeColors['color-primary-500'],
    width: px(10),
    height: px(10),
    top: px(11),
    left: px(3),
    zIndex: 1,
    borderRadius: px(50),
  },
});

export default BottomTabBar;
